document.addEventListener('DOMContentLoaded', function() {
  // Cart quantity update functionality
  const cartQtyBtns = document.querySelectorAll('.cart-qty-btn');
  const cartRemoveBtns = document.querySelectorAll('.cart-item-remove');

  // Function to update cart count in header
  function updateCartCount(itemCount) {
    const cartCountElement = document.querySelector('.cart-count');
    if (cartCountElement) {
      cartCountElement.textContent = itemCount;
    }
  }

  // Update cart quantity
  function updateCartQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Update cart count in header
      updateCartCount(data.item_count);

      // Update cart dynamically without page reload
      updateCartDisplay(data);
    })
    .catch(() => {
      alert('Error updating cart. Please refresh the page.');
    });
  }

  // Update cart display with new data
  function updateCartDisplay(cart) {
    // Update cart total
    const cartTotal = document.querySelector('.cart-total-value');
    if (cartTotal && cart.total_price !== undefined) {
      const formattedTotal = (cart.total_price / 100).toFixed(2);
      cartTotal.textContent = '€' + formattedTotal;
    }

    // Update cart subtotal
    const cartSubtotal = document.querySelector('.cart-subtotal-value');
    if (cartSubtotal && cart.items_subtotal_price !== undefined) {
      const formattedSubtotal = (cart.items_subtotal_price / 100).toFixed(2);
      cartSubtotal.textContent = '€' + formattedSubtotal;
    }

    // Update line item totals
    cart.items.forEach((item, index) => {
      const lineTotal = document.querySelector(`[data-line="${index + 1}"] .cart-item-total`);
      if (lineTotal && item.line_price !== undefined) {
        const formattedPrice = (item.line_price / 100).toFixed(2);
        lineTotal.textContent = '€' + formattedPrice;
      }
    });

    // Remove items with 0 quantity
    cart.items.forEach((item, index) => {
      if (item.quantity === 0) {
        const cartItem = document.querySelector(`[data-line="${index + 1}"]`);
        if (cartItem) {
          cartItem.remove();
        }
      }
    });

    // If cart is empty, reload to show empty state
    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  // Handle quantity buttons
  cartQtyBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const line = parseInt(this.getAttribute('data-line'));
      const input = document.querySelector(`.cart-qty-input[data-line="${line}"]`);
      let currentQty = parseInt(input.value);

      if (this.classList.contains('cart-qty-decrease')) {
        if (currentQty > 1) {
          currentQty--;
          input.value = currentQty;
          updateCartQuantity(line, currentQty);
        }
      } else if (this.classList.contains('cart-qty-increase')) {
        currentQty++;
        input.value = currentQty;
        updateCartQuantity(line, currentQty);
      }
    });
  });

  // Handle remove buttons
  cartRemoveBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const line = parseInt(this.getAttribute('data-line'));

      // Confirm removal
      if (confirm('Ar tikrai norite pašalinti šią prekę iš krepšelio?')) {
        updateCartQuantity(line, 0);
      }
    });
  });

  // ============================================
  // DISCOUNT CODE FUNCTIONALITY
  // ============================================

  const discountForm = document.getElementById('discount-form');
  const discountInput = document.getElementById('discount-code');
  const discountMessage = document.getElementById('discount-message');
  const removeDiscountBtn = document.getElementById('remove-discount');
  const checkoutBtn = document.getElementById('checkout-btn');

  // Apply discount code
  if (discountForm && discountInput) {
    discountForm.addEventListener('submit', function(e) {
      e.preventDefault();

      const discountCode = discountInput.value.trim();

      if (!discountCode) {
        showMessage('Prašome įvesti nuolaidos kodą', 'error');
        return;
      }

      // Save discount code to cart attributes
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            discount_code: discountCode
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        showMessage('Nuolaidos kodas išsaugotas. Jis bus pritaitytas prie kasos.', 'success');

        // Update discount display without reload
        const discountDisplay = document.querySelector('.discount-code-display');
        if (discountDisplay) {
          discountDisplay.style.display = 'block';
        }
        if (removeDiscountBtn) {
          removeDiscountBtn.style.display = 'inline-block';
        }
      })
      .catch(() => {
        showMessage('Įvyko klaida. Prašome bandyti dar kartą.', 'error');
      });
    });
  }

  // Remove discount code
  if (removeDiscountBtn) {
    removeDiscountBtn.addEventListener('click', function(e) {
      e.preventDefault();

      // Clear the discount code from cart attributes
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            discount_code: ''
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        // Clear discount input
        if (discountInput) {
          discountInput.value = '';
        }
        showMessage('Nuolaidos kodas pašalintas. Perkraunamas krepšelis...', 'success');

        // Redirect to cart to clear discount from session
        // This clears any discount codes applied to the cart
        setTimeout(() => {
          window.location.href = '/cart?discount=';
        }, 500);
      })
      .catch(() => {
        showMessage('Įvyko klaida. Prašome bandyti dar kartą.', 'error');
      });
    });
  }

  // Apply discount code to checkout URL
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async function(e) {
      e.preventDefault();

      // Disable button to prevent double clicks
      checkoutBtn.disabled = true;
      const originalText = checkoutBtn.textContent;
      checkoutBtn.textContent = 'Ruošiama...';

      try {
        // Validate shipping method is selected
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        if (!cartData.attributes || !cartData.attributes.shipping_method) {
          alert('Prašome pasirinkti pristatymo būdą prieš pereinant prie kasos.');
          // Scroll to shipping selector
          const shippingSelector = document.getElementById('shippingSelector');
          if (shippingSelector) {
            shippingSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = originalText;
          return;
        }

        // Add shipping product to cart NOW (only for parcel machines)
        if (cartData.attributes.shipping_method === 'parcel') {
          console.log('Adding shipping product before checkout...');

          const shippingData = {
            method: cartData.attributes.shipping_method,
            provider: cartData.attributes.shipping_provider,
            machine_name: cartData.attributes.shipping_machine_name,
            machine_address: cartData.attributes.shipping_machine_address,
            machine_city: cartData.attributes.shipping_machine_city,
            machine_zip: cartData.attributes.shipping_machine_zip
          };

          // Call the addShippingProduct function from shipping selector
          if (window.shippingSelectorInstance) {
            const added = await window.shippingSelectorInstance.addShippingProductForCheckout(shippingData);
            if (!added) {
              // Failed to add shipping product
              checkoutBtn.disabled = false;
              checkoutBtn.textContent = originalText;
              return;
            }
          }
        }

        // Clear the navigation flag since we're going to checkout
        sessionStorage.removeItem('shouldRemoveShipping');

        // Mark that we're proceeding to checkout
        sessionStorage.setItem('proceedingToCheckout', 'true');

        const discountCode = discountInput ? discountInput.value.trim() : '';

        // Build checkout URL with discount code
        let checkoutUrl = '/checkout';
        if (discountCode) {
          checkoutUrl += '?discount=' + encodeURIComponent(discountCode);
        }

        console.log('Proceeding to checkout:', checkoutUrl);
        window.location.href = checkoutUrl;
      } catch (error) {
        console.error('Checkout error:', error);
        alert('Įvyko klaida. Prašome bandyti dar kartą.');
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = originalText;
      }
    });
  }

  // Show message function
  function showMessage(message, type) {
    if (discountMessage) {
      discountMessage.textContent = message;
      discountMessage.className = 'discount-code-message ' + type;
      discountMessage.style.display = 'block';

      // Hide message after 5 seconds
      setTimeout(() => {
        discountMessage.style.display = 'none';
      }, 5000);
    }
  }
});
